module.exports = __webpack_public_path__ + "static/IMG_2608-3fcf408cc1026212399a38fdf7fa50b2.jpg";